import React from 'react';
import { ArrowRight, MessageSquare, Star, ShieldCheck, Truck, BadgeCheck } from 'lucide-react';
import { FEATURES, CONTACT } from '../mock';
import useRandomFont from '../hooks/useRandomFont';

const featureIcons = [ShieldCheck, Truck, BadgeCheck];

const STAR_KEYS = ['star-1', 'star-2', 'star-3', 'star-4', 'star-5'];

const Hero = () => {
  const smsHref = `sms:+1${CONTACT.phone}?&body=${CONTACT.smsBody}`;
  const fontClass = useRandomFont();

  return (
    <section id="top" className="relative overflow-hidden bg-app">
      <div className="absolute inset-0 bg-grid opacity-70" />
      <div className="absolute inset-0 hero-glow" />
      <div className="relative max-w-7xl mx-auto px-5 lg:px-8 pt-36 pb-20">
        <div className="text-center animate-fadeUp">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/5 border border-white/10 text-[11px] tracking-[0.25em] text-gray-300 uppercase">
            <span className="w-2 h-2 rounded-full bg-sky-400 pulse-dot" /> Now Booking Repairs
          </div>

          <div className="mt-8 flex justify-center">
            <span className="laser-wrap">
              <h1 className="bomb-title font-display text-[clamp(3rem,9vw,6.5rem)] leading-[0.95] title-glow">
                WE FIX TECH
              </h1>
              <span className="laser-beam" aria-hidden="true" />
              <span className="laser-dot" aria-hidden="true" />
              <span className="explosion" aria-hidden="true" />
            </span>
          </div>

          <p className="mt-2 text-[clamp(2.2rem,6vw,4.5rem)] font-800 bg-gradient-to-r from-white via-gray-300 to-gray-500 bg-clip-text text-transparent leading-none">
            <span className={`rf-swap ${fontClass}`}>Fast &amp; Reliable.</span>
          </p>

          <p className="mt-8 max-w-2xl mx-auto text-gray-400 text-base md:text-lg leading-relaxed">
            Expert repair for laptops, desktops, game consoles, phones, and tablets.
            Precision diagnostics, board-level repair, and quality parts — backed by a
            90-day warranty and no-fix, no-fee guarantee.
          </p>

          <div className="mt-9 flex flex-col sm:flex-row items-center justify-center gap-4">
            <a href="#services" className="btn-blue px-7 py-3.5 rounded-md font-semibold flex items-center gap-2">
              View Services <ArrowRight className="w-4 h-4" />
            </a>
            <a href={smsHref} className="btn-dark px-7 py-3.5 rounded-md font-semibold flex items-center gap-2">
              <MessageSquare className="w-4 h-4" /> Get SMS Quote
            </a>
          </div>

          <div className="mt-6 flex items-center justify-center gap-2 text-sm text-gray-400">
            <span className="flex items-center gap-0.5">
              {STAR_KEYS.map((k) => (
                <Star key={k} className="w-4 h-4 fill-sky-400 text-sky-400" />
              ))}
            </span>
            Trusted by 500+ local customers
          </div>
        </div>

        <div className="mt-20 grid md:grid-cols-3 gap-5">
          {FEATURES.map((f, i) => {
            const Icon = featureIcons[i];
            return (
              <div key={f.title} className="feature-card rounded-xl p-6">
                <span className="inline-flex w-10 h-10 rounded-lg bg-sky-500/15 items-center justify-center">
                  <Icon className="w-5 h-5 text-sky-400" />
                </span>
                <h3 className="mt-4 font-cond font-600 text-lg text-white">{f.title}</h3>
                <p className="mt-1.5 text-sm text-gray-400">{f.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Hero;
